// 迁移 Vite 后运行报错，增加下面一行代码可解决
import 'vue'
import { install } from './components'
import './assets/svg'

export * from './components'
export * from './composables'
export * from './plugins'
export * from './utils'

export default {
  install,
}
